import cmp from './IconButton'

export default cmp
